@switch (type) {
    @case ('spinner') {
        <div
            class="spinner-container"
            [class.spinner-container--overlay]="overlay"
            [style.minHeight]="MIN_HEIGHT"
        >
            <div class="absolute-center d-flex flex-column align-items-center">
                <wdx-spinner></wdx-spinner>
                @if (hasError) {
                    <h6 class="mt-1">
                        {{ SOMETHING_WENT_WRONG | translateTokenisedString }}
                    </h6>
                }
            </div>
        </div>
    }
    @case ('dot') {
        <span class="dot-loader"></span>
    }
}
